import React from "react";
import { ListBlock } from "./items-grid";
import Slider from "react-slick";
import { Link } from "./link";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";

const settings = {
  dots: true,
  autoplay: true,
  arrows: false,
  swipe: true,
  autoplaySpeed: "6000",
  slide: "box-stories",
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        infinite: false,
        centerMode: true,
        centerPadding: "50px",
      },
    },
  ],
};

const GalleryElement = ({ item }) => {
  return (
    <div className="box-stories box-stories--dynamic-gallery d-flex flex-column flex-md-row">
      {item?.icon?.icon && !item?.image?.[0]?.node && (
        <img
          className="box-stories__img box-stories--dynamic-gallery__icon"
          src={item?.icon?.icon?.node?.publicURL}
          style={{
            width: item?.icon?.width && `${item?.icon?.width}px`,
            height: item?.icon?.heigth && `${item?.icon?.heigth}px`,
          }}
          alt={item?.title || ""}
        />
      )}
      {item?.image?.[0]?.node && (
        <GatsbyImage
          className="box-stories__img"
          image={getImage(item?.image?.[0]?.node)}
          alt={item?.image?.[0]?.alt || ""}
          loading="eager"
        />
      )}

      {item?.title && (
        <h3 className="box-stories__title align-self-center box-stories--dynamic-gallery__title">
          {item.title}
        </h3>
      )}
      {item?.realSubTitle && (
        <div className="box-stories--dynamic-gallery__subtitle">{item.realSubTitle}</div>
      )}
      {item?.subtitle && (
        <div
          className="box-stories__desc box-stories--dynamic-gallery__desc d-md-none"
          dangerouslySetInnerHTML={{ __html: item.subtitle }}
        />
      )}
      {item?.cta?.[0]?.link && item?.cta?.[0]?.linkLabel && (
        <Link
          className={classNames(
            `box-stories--dynamic-gallery__link btn-link`,
            item?.cta?.[0]?.btnColor === "White" && "btn-link--white",
            item?.cta?.[0]?.btnColor === "Blu" && "btn-link--blue",
            item?.cta?.[0]?.btnColor === "Black" && "btn-link--black"
          )}
          to={item?.cta?.[0]?.link}
        >
          {item?.cta?.[0]?.linkLabel}
        </Link>
      )}
    </div>
  );
};

const DynamicAsGallery = ({
  type,
  list,
  md,
  lg,
  showVideoModal,
  labelManagerLabels,
  isProduct,
  addItemToCart,
  isFirstModule,
  dataMagento,
  origin,
  dataZuora,
  config,
}) => {
  return (
    <>
      <div className="d-none d-md-flex justify-content-md-center flex-md-wrap">
        <ListBlock
          type={type}
          list={list}
          md={md}
          lg={lg}
          showVideoModal={showVideoModal}
          labelManagerLabels={labelManagerLabels}
          isProduct={isProduct}
          addItemToCart={addItemToCart}
          isFirstModule={isFirstModule}
          dataMagento={dataMagento}
          origin={origin}
          dataZuora={dataZuora}
          config={config}
        />
      </div>
      <section className="d-md-none section haier-stories">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 px-0">
              <Slider
                {...settings}
                className="haier-stories__grid haier-stories__grid--dynamic-gallery slider-haier-stories mt-4"
              >
                {list.map((item, i) => (
                  <GalleryElement item={item} key={i} />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default DynamicAsGallery;
